function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo_meusdocs");

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "685.695px",
    height: "271.543px",
    viewBox: "105.732 164.674 685.695 271.543",
    enableBackground: "new 105.732 164.674 685.695 271.543",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m157.6 309.73 26.757-128.88h13.941v158.09h-10.793v-61.673l1.068-66.125-26.926 127.8h-8.207l-26.87-128.02 1.068 66.342v61.673h-10.793v-158.09h13.941z",
    fill: "#4a4a48",
    strokeWidth: 0.9111,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.15 338.94v-158.09h51.434v17.156h-40.585v50.815h35.414v17.047h-35.414v56.027h41.148v17.047z",
    fill: "#4a4a48",
    strokeWidth: 0.9111,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.22 180.85h10.793v106.95q0 26.711-8.8816 40.066-8.8816 13.247-20.799 13.247-12.535 0-21.08-13.247-8.4881-13.355-8.4881-40.066v-106.95h10.737v106.95q0 18.567 5.1716 27.471 5.2278 8.7949 13.66 8.7949 8.5443 0 13.716-8.7949 5.1716-8.9035 5.1716-27.471z",
    fill: "#4a4a48",
    strokeWidth: 0.9111,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.47 298.98q0-10.858-3.8224-17.373-3.7662-6.5148-15.908-13.355-12.142-6.9491-19.225-17.59-7.0266-10.749-7.0266-28.991 0-18.458 7.5887-30.728 7.6449-12.269 20.236-12.269 13.828 0 21.305 14.658 7.5325 14.658 7.5325 33.117h-10.793q0-13.247-4.4408-21.933-4.4408-8.6864-13.603-8.6864-8.6567 0-12.816 7.3834-4.1597 7.2748-4.1597 18.241 0 9.8807 4.3846 16.504 4.4408 6.5148 14.39 11.944 14.222 7.7092 20.742 19.11 6.5206 11.292 6.5206 29.751 0 19.327-7.8135 30.837-7.8135 11.509-20.742 11.509-7.5325 0-14.671-5.429-7.0828-5.429-11.692-16.07-4.5532-10.749-4.5532-26.493h10.793q0 16.178 6.1272 23.562 6.1272 7.3834 13.997 7.3834 8.4881 0 13.041-6.7319 4.6094-6.8405 4.6094-18.35z",
    fill: "#4a4a48",
    strokeWidth: 0.9111,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.95 419.48v-237.54h30.934q21.549 0 34.839 30.182 13.365 30.019 13.365 81.572v14.194q0 51.554-13.44 81.572-13.365 30.019-36.115 30.019zm14.491-211.76v186.15h15.092q17.494 0 26.354-23.493 8.8598-23.493 8.8598-62.484v-14.52q0-40.949-8.8598-63.3-8.8598-22.351-25.003-22.351z",
    fill: "#43b0bf",
    strokeWidth: 1.1477,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.68 308.21q0 53.511-11.938 84.019-11.938 30.508-31.91 30.508-19.447 0-31.76-30.508-12.314-30.508-12.314-84.019v-15.009q0-53.348 12.239-83.856 12.239-30.671 31.685-30.671 19.822 0 31.76 30.182 12.013 30.019 12.239 82.388zm-14.341-15.336q0-42.418-7.8087-64.931-7.8087-22.514-21.849-22.514-13.44 0-21.549 22.514-8.0339 22.514-8.0339 64.931v15.336q0 42.744 8.109 65.421 8.1841 22.514 21.624 22.514 14.116 0 21.774-22.514 7.7336-22.677 7.7336-65.421z",
    fill: "#43b0bf",
    strokeWidth: 1.1477,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m671.87 343.94h14.416q-1.6518 33.771-11.713 56.285-10.061 22.514-29.733 22.514-19.071 0-30.784-29.529-11.638-29.692-11.863-78.799v-25.451q0-49.922 11.788-80.104 11.863-30.182 32.136-30.182 18.546 0 28.532 22.188 9.9861 22.188 11.638 57.264h-14.416q-1.6518-24.798-7.3582-39.155-5.7064-14.52-18.395-14.52-14.491 0-21.999 23.166-7.5084 23.167-7.5084 61.016v23.982q0 35.076 6.8326 59.874 6.8326 24.635 21.399 24.635 13.815 0 19.447-14.03 5.7064-14.03 7.5834-39.155z",
    fill: "#43b0bf",
    strokeWidth: 1.1477,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m756.8 359.44q0-16.314-5.1057-26.103-5.0306-9.7887-21.249-20.067-16.218-10.441-25.679-26.429-9.3854-16.151-9.3854-43.56 0-27.735 10.136-46.17 10.211-18.435 27.03-18.435 18.471 0 28.457 22.024 10.061 22.024 10.061 49.759h-14.416q0-19.904-5.9316-32.955-5.9316-13.052-18.17-13.052-11.563 0-17.119 11.094-5.5562 10.931-5.5562 27.408 0 14.846 5.8565 24.798 5.9316 9.7887 19.221 17.946 18.996 11.583 27.706 28.713 8.7097 16.967 8.7097 44.702 0 29.04-10.437 46.333-10.437 17.293-27.706 17.293-10.061 0-19.597-8.1572-9.4605-8.1572-15.617-24.145-6.0818-16.151-6.0818-39.807h14.416q0 24.309 8.1841 35.402 8.1841 11.094 18.696 11.094 11.338 0 17.419-10.115 6.1569-10.278 6.1569-27.571z",
    fill: "#43b0bf",
    strokeWidth: 1.1477,
    style: {
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.5b8ab593.svg";
export { ForwardRef as ReactComponent };